/**
 * Created with IntelliJ IDEA.
 * User: pburst
 * Date: 20.09.12
 * Time: 16:37
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class MobileLoginTimeTrackingEvent extends BasicTrackingEvent {
    public static IS_FIRST_USER: number = 1;
    public static IS_FIRST_APP_START_AFTER_UPDATE: number = 2;
    public static IS_REGULAR_USER: number = 3;

    public gameId: number;
    public networkId: number;
    public instanceID: number;
    public playerID: number;
    public accountID: string;
    public deviceId: number;
    public storeId: number;

    public loginTime: number;
    public loginTimeMs: number;
    public downloadRate: number;
    public downloadContentSizeExternal: number;
    public downloadContentSizeLocal: number;
    public downloadContentAmountExternal: number;
    public downloadContentAmountLocal: number;
    public connectionType: string;

    public sessionType: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.gameId = this.gameId;
        vars.networkId = this.networkId;
        vars.instanceId = this.instanceID;
        vars.playerId = this.playerID;
        vars.var_1 = this.accountID;
        vars.var_2 = this.deviceId;
        vars.var_3 = this.storeId;

        vars.var_4 = this.loginTime;
        vars.var_5 = this.downloadRate;
        vars.var_6 = this.downloadContentSizeExternal;
        vars.var_7 = this.downloadContentSizeLocal;
        vars.var_data = this.connectionType + ";" + this.downloadContentAmountExternal + ";" + this.downloadContentAmountLocal + ";" + String(this.sessionType) + ";" + String(this.loginTimeMs);
        return vars;
    }
}
